import { useClientStore } from '@/client/stores/client';
import { withErrorHandling } from '@/client/utils/errors';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NAV_PINS, navPinKeys, normalizePins, unwrapEnvelope } from './nav-pins.query';

const TIMEOUT = { timeout: 15_000 };

export const useSaveNavPinsMutation = () => {
  const request = useClientStore((s) => s.request);
  const qc = useQueryClient();

  const fn = withErrorHandling(async (pins: string[]) => {
    const raw = await request<any>(
      NAV_PINS,
      'PUT',
      { pins: normalizePins(pins) },
      TIMEOUT,
    );
    const payload = unwrapEnvelope(raw);
    return normalizePins(payload?.pins ?? pins);
  }, 'Failed to save nav pins');

  return useMutation({
    mutationFn: (pins: string[]) => fn(pins),
    onSuccess: (pins) => {
      qc.setQueryData(navPinKeys.list(), pins);
    },
  });
};
